import { render, staticRenderFns } from "./back_gum_type.vue?vue&type=template&id=f2951e6e&scoped=true"
import script from "./back_gum_type.vue?vue&type=script&lang=js"
export * from "./back_gum_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2951e6e",
  null
  
)

export default component.exports